import React from 'react';

import {
    AbilityLookup,
    BaseFeat,
    DataOriginBaseAction,
    DataOriginRefData,
    DataOriginSpell,
    RacialTrait,
    RacialTraitUtils,
    RuleData,
    SnippetData,
    AccessUtils,
    CharacterTheme,
} from '@dndbeyond/character-rules-engine/es';

import FeatureSnippet from '../FeatureSnippet';

interface Props {
    racialTrait: RacialTrait;
    extraMeta: Array<string>;

    onActionClick?: (action: DataOriginBaseAction) => void;
    onActionUseSet?: (action: DataOriginBaseAction, uses: number) => void;
    onSpellClick?: (spell: DataOriginSpell) => void;
    onSpellUseSet?: (spell: DataOriginSpell, uses: number) => void;
    onFeatureClick?: (feature: RacialTrait) => void;

    showHeader?: boolean;
    showDescription?: boolean;

    feats: Array<BaseFeat>;
    snippetData: SnippetData;
    ruleData: RuleData;
    abilityLookup: AbilityLookup;
    dataOriginRefData: DataOriginRefData;
    isReadonly: boolean;
    proficiencyBonus: number;
    theme: CharacterTheme;
}
export default class RacialTraitFeatureSnippet extends React.PureComponent<Props> {
    static defaultProps = {
        extraMeta: [],
        showDescription: false,
    };

    handleFeatureClick = (): void => {
        const { racialTrait, onFeatureClick } = this.props;

        if (onFeatureClick) {
            onFeatureClick(racialTrait);
        }
    };

    renderDescription = (): React.ReactNode => {
        const { racialTrait, showDescription } = this.props;

        const description: string | null = AccessUtils.isAccessible(RacialTraitUtils.getAccessType(racialTrait))
            ? RacialTraitUtils.getDescription(racialTrait)
            : 'Check out the Marketplace to unlock this Racial Trait.';

        return showDescription ? description : RacialTraitUtils.getSnippet(racialTrait);
    };

    render() {
        const { racialTrait, onFeatureClick, showDescription, ...restProps } = this.props;

        return (
            <FeatureSnippet
                {...restProps}
                heading={RacialTraitUtils.getName(racialTrait)}
                className="ct-feature-snippet--racial-trait"
                actions={RacialTraitUtils.getActions(racialTrait)}
                options={RacialTraitUtils.getOptions(racialTrait)}
                choices={RacialTraitUtils.getChoices(racialTrait)}
                spells={RacialTraitUtils.getSpells(racialTrait)}
                sourceId={RacialTraitUtils.getSourceId(racialTrait)}
                sourcePage={RacialTraitUtils.getSourcePage(racialTrait)}
                onFeatureClick={this.handleFeatureClick}
                showDescription={showDescription}
            >
                {this.renderDescription()}
            </FeatureSnippet>
        );
    }
}
